// import './breadCrumb.scss';

import {FunctionalComponent, h} from "preact";

export const BreadCrumb: FunctionalComponent<{ breadcrumbData: any; castGotoCB: (bcData: any) => void }> = ({breadcrumbData, castGotoCB}) => {

  if (!breadcrumbData) return null;

    const butts = breadcrumbData.map(
        (bcRawObj: any) => (
            <button onClick={(e) => {
                e.preventDefault();
                castGotoCB(bcRawObj)
            }}>
                {bcRawObj.label}
            </button>
        ));
    
    return <div className="answers" id="breadcrumb">{butts}</div>
};
